module.exports = __webpack_public_path__ + "img/icon-notifications.09e377be.svg";